import { render, staticRenderFns } from "./SalePaymentApproval.vue?vue&type=template&id=dc440e18"
import script from "./SalePaymentApproval.vue?vue&type=script&lang=js"
export * from "./SalePaymentApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports